var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Home'),(_vm.disclaimer)?_c('finePrints',{attrs:{"disclaimer":_vm.disclaimer}}):_vm._e(),(_vm.dtm)?_c('PageView',{attrs:{"pageName":"vehicles|new|leaf|range-charging|rangecalculator"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }